"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClientWithAmplifyInstance = exports.InternalAPIClass = exports.InternalAPI = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var InternalAPI_1 = require("./InternalAPI");
Object.defineProperty(exports, "InternalAPI", { enumerable: true, get: function () { return InternalAPI_1.InternalAPI; } });
Object.defineProperty(exports, "InternalAPIClass", { enumerable: true, get: function () { return InternalAPI_1.InternalAPIClass; } });
var server_1 = require("@aws-amplify/api-graphql/internals/server");
Object.defineProperty(exports, "generateClientWithAmplifyInstance", { enumerable: true, get: function () { return server_1.generateClientWithAmplifyInstance; } });
